module.exports = __webpack_public_path__ + "static/retail_hero-030a949cb8f3350ffb34e64365ab05b1.jpg";